import { PropsWithChildren } from 'react'

import Logo from 'assets/images/logo.svg'

import styles from './AccessPage.module.scss'

const AccessPage = ({ children }: PropsWithChildren) => (
  <div className={styles.access}>
    <div>
      <div className={styles.logo}>
        <Logo className={styles.logo} />
      </div>
      {children}
    </div>
  </div>
)

export default AccessPage
